import {Routes, Route} from 'react-router-dom';
import AppLayout from './layout/AppLayout/AppLayout';
import NotFound from './pages/NotFound';
import WebFont from 'webfontloader';
import DebugHome from './pages/DebugHome';
import {Authorization} from './components/Authorization';
import SelectTimePage from './pages/SelectTimePage';
import ContactInfoPage from './pages/ContactInfoPage';
import ReviewPage from './pages/ReviewPage';
import {RoutePath} from './lib/enums';
import ConfirmationPage from './pages/ConfirmationPage';
import MyBookingPage from './pages/MyBookingPage';
import LogoutPage from './pages/LogoutPage';
import {CustomOccasionPage} from './pages/CustomOccasionPage';
import {DEBUGMODE, REACT_APP_ENV, UPPSALA_FONTS_URL} from './utils/constants';
import {useEffect} from 'react';

// Matomo Tag Manager
declare global {
  interface Window {
    _mtm: any[];
  }
}

function App() {
  // Load fonts here to avoid FOUT (Flash of Unstyled Text)
  useEffect(() => {
    WebFont.load({
      custom: {
        families: ['Source Sans Pro', 'sans-serif', 'arial'],
        urls: [UPPSALA_FONTS_URL],
      },
    });

    // Matomo Tag Manager - env is set in pipeline build
    console.log('REACT_APP_ENV', REACT_APP_ENV);
    if (REACT_APP_ENV === 'production' || REACT_APP_ENV === 'development') {
      var _mtm = (window._mtm = window._mtm || []);
      _mtm.push({'mtm.startTime': new Date().getTime(), event: 'mtm.Start'});
      var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = 'https://matomo.uppsala.se/js/container_JKokYpkR.js';
      if (s && s.parentNode) {
        s.parentNode.insertBefore(g, s);
      }
    }
  }, []);

  return (
    <AppLayout>
      <Routes>
        {DEBUGMODE && <Route path={RoutePath.Debug} element={<DebugHome />} />}

        <Route path={RoutePath.HomePage} element={<SelectTimePage />} />
        <Route path={RoutePath.CustomBookingPage} element={<CustomOccasionPage />} />
        {/* Put protected routes inside the Route below */}
        <Route element={<Authorization />}>
          <Route path={RoutePath.ContactInfoPage} element={<ContactInfoPage />} />
          <Route path={RoutePath.ReviewPage} element={<ReviewPage />} />
          <Route path={RoutePath.ConfirmationPage} element={<ConfirmationPage />} />
          <Route path={RoutePath.MyPages} element={<MyBookingPage />} />
          <Route path={RoutePath.RebookBookingPage} element={<SelectTimePage inRebookMode />} />
        </Route>

        <Route path={RoutePath.LogoutPage} element={<LogoutPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppLayout>
  );
}

export default App;
